module.exports = __webpack_public_path__ + "img/smart-grids.943bb8d8.webp";